/**
 * Library with constants and utitlity functions based on screen realestate
 * @author Moeed Ahmad <moeeed@250mils.com>
 */

export enum ScreenBreakpoints {
  XS = '480',
  SMALL = '576',
  MEDIUM = '768',
  TABLET = '896',
  LARGE = '992',
  LAPTOP = '1366',
  WIDESCREEN = '1920',
  XL = '1400',
  MOBILE_MODAL_ACTIVATION_BREAKPONT = '550',
  HOMEPAGE_MOBILE_BREAKPOINT = '950',
  AI_CHAT_SMALL_BREAKPOINT = '1110',
  BG_REMOVER_UPSELL_BREAKPOINT = '850',
  EMAIL_CAMPAIGN_SETTINGS_TABS_BREAKPOINT = '945',
  QR_TOOL_COMPACT_BREAKPOINT = '767',
  QR_TOOL_ICON_ONLY_ACTIONS_BREAKPOINT = '559',
  BRAND_KITS_TABLET_BREAKPOINT = '900',
}

/**
 * Viewport check for non-hook call sites (click handlers, libraries). Components rendering on
 * resize should prefer the `useIsSmallerThanBreakpointWidth` hook instead.
 */
export function isTabletWidthOrSmaller(): boolean {
  return window.innerWidth <= Number(ScreenBreakpoints.TABLET);
}

/** The non-hook twin of `useIsSmallerThanBreakpointWidth`: true at or below the breakpoint, read once. */
export function isSmallerThanBreakpointWidth(breakpointWidth: ScreenBreakpoints): boolean {
  return getMediaQueryForBreakpoint(breakpointWidth).matches;
}

/** `max-width: Npx` semantics, so it matches at the breakpoint itself (`<=`). */
export function getMediaQueryForBreakpoint(breakpointWidth: ScreenBreakpoints): MediaQueryList {
  return window.matchMedia(`(max-width: ${breakpointWidth}px)`);
}
